import { useLocation } from "react-router";
import { useWindowDimensions } from "hooks/useWindowDimensions";
import { useCartContext } from "context/cart-context";
import { Button, Input } from "components/UI/atoms";
import plusIcon from "assets/images/plus.svg";
import minusIcon from "assets/images/minus.svg";
import cartIcon from "assets/icons/brand/cart.svg";
import { useHandleGroupedRowValue } from "./utils/useHandleGroupedRowValue";
import { MAX_CARD_AMOUNT, REDUCER_ACTIONS } from "./utils/constants";
import "./index.scss";

export const GroupedDiscountRow = ({
  value,
  discount,
  price,
  quantity,
  productSourceId,
  onSuccessInAddingToCart
}) => {
  const { pathname } = useLocation();
  const {
    cart: { isCartLoading },
    toggleCartOpening
  } = useCartContext();

  const { cardAmount, handleAddToCart, handleCardAmount } =
    useHandleGroupedRowValue();

  const maxCardLimitReached =
    cardAmount === MAX_CARD_AMOUNT || cardAmount === quantity;
  const maxCardCount = cardAmount > quantity;
  const minCardLimitReached = cardAmount === 1;

  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  const formatPrice = (price, multiplier = 1) => {
    return typeof price === "string"
      ? Number(price.replace(/[$%]/, "") * multiplier).toFixed(2)
      : Number(price * multiplier).toFixed(2);
  };
  const brandSlug = pathname.replace("/", "");

  const handleAddItemToCart = async () => {
    try {
      await handleAddToCart({
        brandSlug,
        discount,
        price,
        productSourceId,
        value
      });
      toggleCartOpening();
      await onSuccessInAddingToCart();
    } catch (error) {
      // do nothing, the handleAddToCart function will show error notification
    }
  };

  return (
    <tr className="grouped-discount-row" data-testid="grouped-discount-row">
      <td className="value">${formatPrice(value)}</td>
      {isMobile ? (
        <td className="your-price">
          <span className="discount">{formatPrice(discount, 100)}% OFF</span>
          <span className="value">${formatPrice(price)}</span>
        </td>
      ) : (
        <>
          <td className="discount">
            <span className="discount">{formatPrice(discount, 100)}% OFF</span>
          </td>
          <td className="value">${formatPrice(price)}</td>
        </>
      )}
      <td className="quantity">{quantity}</td>
      {isMobile ? (
        <td>
          <Input
            id="amount"
            name="amount"
            value={cardAmount}
            onInput={(event) =>
              handleCardAmount({
                type: REDUCER_ACTIONS.UPDATE_QUANTITY_ON_MOBILE_FIELD,
                payload: event.target.value
              })
            }
            inputMode="numeric"
            className="input-amount"
            pattern="\d*"
          />
        </td>
      ) : (
        <>
          <td className="card-counter">
            <img
              src={minusIcon}
              alt="minus"
              className={`counter-down ${minCardLimitReached && "disabled"}`}
              onClick={() => {
                handleCardAmount({
                  type: REDUCER_ACTIONS.SUBTRACT_QUANTITY
                });
              }}
            />
            {cardAmount}
            <img
              src={plusIcon}
              alt="plus"
              className={`counter-up ${maxCardLimitReached && "disabled"}`}
              onClick={() => {
                handleCardAmount({
                  type: REDUCER_ACTIONS.ADD_QUANTITY
                });
              }}
            />
          </td>
        </>
      )}
      <td>
        <Button
          customClassName="add-button"
          disabled={isCartLoading || maxCardCount}
          onClick={() => {
            void handleAddItemToCart();
          }}
        >
          {isMobile ? <img src={cartIcon} alt="Add to cart" /> : "ADD TO CART"}
        </Button>
      </td>
    </tr>
  );
};
